import { render, staticRenderFns } from "./CustomerApprove.vue?vue&type=template&id=5050bd26&scoped=true&"
import script from "./CustomerApprove.vue?vue&type=script&lang=js&"
export * from "./CustomerApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5050bd26",
  null
  
)

export default component.exports